import React, { createContext, useContext, useMemo } from 'react';
import { useUserInfo } from '../../context/UserInfo';

type TimeTrackingContextValue = {
  employeeId: string;
  isManagerView: boolean;
};

const TimeTrackingContext = createContext<TimeTrackingContextValue | null>(
  null,
);

type TimeTrackingProviderProps = {
  employeeId: string;
  children: React.ReactNode;
};

export const TimeTrackingProvider: React.FC<
  React.PropsWithChildren<TimeTrackingProviderProps>
> = ({ employeeId, children }) => {
  const { id: meId } = useUserInfo();

  const value = useMemo(
    () => ({
      employeeId,
      isManagerView: employeeId !== meId,
    }),
    [employeeId, meId],
  );

  return (
    <TimeTrackingContext.Provider value={value}>
      {children}
    </TimeTrackingContext.Provider>
  );
};

export const useTimeTrackingContext = (): TimeTrackingContextValue => {
  const context = useContext(TimeTrackingContext);
  const { id: meId } = useUserInfo();

  const fallbackValue = useMemo(
    () => ({
      employeeId: meId,
      isManagerView: false,
    }),
    [meId],
  );

  return context ?? fallbackValue;
};
